import React from 'react'
import { MultlpleChoiceQuestionsStyels } from './Style'
import { queryClient as qc } from 'keys'
import { useParams } from 'react-router-dom'
import { getAnswersAndQuestionsFetch, getAnswersFetch, getWordsFetch } from 'store/middlewares/words.crud'
import { useQuery } from '@tanstack/react-query'
import { Divider } from '@mui/material'
import { isEmpty } from 'lodash'
import { SmallSpace } from 'styles/GlobalStyle'
import { primary } from 'styles/theme'
import { Close, Done } from '@mui/icons-material'
import { dark } from 'styles/theme'
import { useSelector } from 'react-redux'

const MultlpleChoiceQuestions = () => {
    const params = useParams()
    const assessmentID = params.assessmentID

    const { assessment } = useSelector(state => state.assessment)

    const questionsData = useQuery({
        queryKey: [qc.answers, assessmentID],
        queryFn: async () => {
            let { data } = await getAnswersAndQuestionsFetch({ id: assessment.id })
            return data
        }
    })

    const { questions, correct_count, total_questions } = questionsData?.data || {}

    const statusItems = {
        correct: {
            color: primary,
            icon: Done,
            className: "correct-answer"
        },
        incorrect: {
            color: "#FF0000",
            icon: Close,
            className: "wrong_answer"
        },
        source: {
            color: dark,
            className: "source_answer"
        }
    }

    return (
        <MultlpleChoiceQuestionsStyels>
            {!questionsData.isLoading && isEmpty(questions) ?
                <div className='no-questions'>
                    {"אין נתוני שאלות הבנה למבדק זה"}
                </div>
                :
                <React.Fragment>
                    {!isEmpty(questions) &&
                        <React.Fragment>
                            <div className='assessment-results'>
                                <div className='mark'>{`ציון כולל ${(correct_count / total_questions).toFixed(2) * 100}%`}</div>
                                <div>{`${correct_count} תשובות נכונות מתוך ${total_questions}`}</div>
                            </div>
                            <div className="question-card">
                                {questions.map((question, index) => {
                                    const { answers, text } = question

                                    return (
                                        <React.Fragment key={question.id}>
                                            <div className='question-item' key={question.id}>
                                                <div className='question-number'>
                                                    {"שאלה מספר "}
                                                    {index + 1}
                                                </div>
                                                <div className='question-text'>{text}</div>
                                                <SmallSpace />
                                                <div className='answers'>
                                                    {answers?.map((answer, index) => {
                                                        const { text: answerText, is_correct, is_answer } = answer

                                                        let statusItem = {}

                                                        if (is_answer && is_correct)
                                                            statusItem = statusItems.correct
                                                        else if (is_answer && !is_correct)
                                                            statusItem = statusItems.incorrect
                                                        else if (is_correct && !is_answer)
                                                            statusItem = statusItems.source

                                                        return (
                                                            <div className={`answer-item`} key={answer.id}>
                                                                <div className='answer-status'>
                                                                    {statusItem?.icon && <statusItem.icon className={statusItem?.className || ""} />}
                                                                    {is_answer && "התשובה שנבחרה"}
                                                                    {is_correct && !is_answer && "התשובה הנכונה"}
                                                                </div>
                                                                <div className={`answer-content ${statusItem.className || ""}`}>
                                                                    <div className='answer-number'>{`${index + 1}.`}</div>
                                                                    <span className='answer-text'>{answerText}</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            <Divider sx={{ borderWidth: 1, borderColor: "#E2E3E3" }} />
                                        </React.Fragment>

                                    )
                                })}
                            </div>
                        </React.Fragment>}
                </React.Fragment>}
        </MultlpleChoiceQuestionsStyels>
    )
}
export default MultlpleChoiceQuestions